import { History } from 'history';

export const navigateToMasterPoolDetails = (rowData: any, language: string, history: History) => {
  const route = 'pages/master-pool/master-pool-details';

  if (
    !rowData?.masterPoolCmhcAccountNumber ||
    !rowData?.masterPoolAccountStatusCode ||
    !rowData?.insuredApprovedLenderCode
  ) {
    console.warn('Incomplete row data. Navigation aborted');
    return;
  }

  const searchExist = !!location.search;
  const masterPoolCmhcAccountNumber = location.search.includes('masterPoolCmhcAccountNumber')
    ? ``
    : `masterPoolCmhcAccountNumber=${rowData.masterPoolCmhcAccountNumber}`;

  history.push(
    `/${language}/${route}${searchExist ? location.search + '&' : '?'}${masterPoolCmhcAccountNumber}` +
      `&masterPoolAccountStatusCode=${rowData.masterPoolAccountStatusCode}` +
      `&lenderCode=${rowData.insuredApprovedLenderCode}&requestType=${rowData.requestType}`
  );
};
